/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <path
    fill="currentColor"
    fillRule="evenodd"
    d="M2.7508 0c-1.5187 0-2.75 1.2312-2.75 2.75v15.5c0 3.0919 2.4404 5.6138 5.5 5.7447V24h15.754c1.5187 0 2.75-1.2312 2.75-2.75v-6c0-1.5188-1.2313-2.75-2.75-2.75h-1.5512l2.2344-2.2344c1.074-1.074 1.074-2.8151 0-3.889l-4.2426-4.2427c-1.0739-1.074-2.8151-1.074-3.8891 0l-2.3054 2.3054V2.75c0-1.5188-1.2313-2.75-2.75-2.75h-6Zm18.504 22.5H9.7037l8.4999-8.5h3.0512c.6903 0 1.25.5596 1.25 1.25v6c0 .6904-.5597 1.25-1.25 1.25ZM14.867 3.1945l-3.3661 3.3662V18.25c0 .1146-.0034.2285-.01.3414l9.3865-9.3864c.4881-.4882.4881-1.2797 0-1.7678l-4.2427-4.2427c-.4881-.4881-1.2796-.4881-1.7677 0ZM4.0008 3.25a.75.75 0 0 1 .75.75v2a.75.75 0 1 1-1.5 0V4a.75.75 0 0 1 .75-.75Zm1.75 12c-1.6568 0-3 1.3431-3 3s1.3432 3 3 3c1.657 0 3-1.3431 3-3s-1.343-3-3-3Z"
    clipRule="evenodd"
  />,
  'MenuDevportalThemeFilled'
);
